// extracted by mini-css-extract-plugin
export default {"btn_quick_nav":"style_btn_quick_nav__r0-lC"};